var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEditConnection(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "-289 381 32 32",
    style: {
      enableBackground: "new -289 381 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#CDE4F7;}\n\t.st1{fill:#74B1E0;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "-267.3,408.2 -271.4,409.4 -270.1,405.4 -262.5,397.8 -259.7,400.6  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-272.5,410.5l1.7-5.5l8.3-8.3l3.8,3.8l-8.3,8.3L-272.5,410.5z M-269.5,405.8l-0.8,2.5l2.5-0.8l6.9-7 l-1.7-1.7L-269.5,405.8z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-275.4,391.8c-5.9,0-12-1.6-12-4.5c0-3,6-4.5,12-4.5c5.9,0,12,1.6,12,4.5 C-263.4,390.2-269.4,391.8-275.4,391.8z M-275.4,384.2c-6.3,0-10.4,1.8-10.4,3c0,1.2,4.1,3,10.5,3c6.4,0,10.5-1.8,10.5-3 C-264.9,386-269,384.2-275.4,384.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-275.4,398.3c-5.9,0-12-1.6-12-4.5h1.5c0,1.2,4.1,3,10.5,3s10.5-1.8,10.5-3h1.5 C-263.4,396.7-269.4,398.3-275.4,398.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-275.4,404.8c-5.9,0-12-1.6-12-4.6h1.5c0,1.2,4.1,3.1,10.5,3.1c0.8,0,1.6,0,2.3-0.1l0.1,1.5 C-273.7,404.8-274.5,404.8-275.4,404.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-275.4,411.3c-5.9,0-12-1.6-12-4.6v-19.5h1.5c0,1.2,4.1,3,10.5,3s10.5-1.8,10.5-3h1.5v8.4h-1.5v-6 c-4.3,2.9-16.6,2.9-20.9,0v17.2c0,1.2,4.1,3.1,10.5,3.1v1.4H-275.4z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditConnection);
export default __webpack_public_path__ + "static/media/edit_connection.2e71bda4df5f9c690d21ff963d8c8d31.svg";
export { ForwardRef as ReactComponent };